import { useCallback, useState } from "react";
import { startAuthentication } from "@simplewebauthn/browser";

export const usePasskeyAuthentication = () => {
  const [isLoading, setIsLoading] = useState(false);

  const authenticate = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await fetch( `${process.env.REACT_APP_BACKEND_URL}/auth/passkey/login/options`, { method: "POST" } ); 
      if (!response.ok) throw new Error("Could not create authentication options.");
      const options = await response.json();
      const { challengeId, ...authenticationOptions } = options;
      const credential = await startAuthentication({
        optionsJSON: authenticationOptions,
        useBrowserAutofill: false
      });
      const verifyResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/auth/passkey/login/verify`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ credential, challengeId })
        }
      );
      const result = await verifyResponse.json();
      if (!verifyResponse.ok) throw new Error(result.message);
      return { success: true, ...result };
    } catch (err) {
      if (err.name === "NotAllowedError") {
        return {
          success: false,
          cancelled: true
        };
      }
      console.error(err);
      return { success: false, error: err.message };
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    authenticate,
    isLoading
  };
};